// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"db6e1779","453":"e8cc2289"}[chunkId] + ".chunk.js";
};